var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { memo, useMemo } from "react";
import { useSelector } from "react-redux";
import { getAppContext, getOptions } from "../store/stateGetter";
import { useTranslation } from "react-i18next";
import styled from "styled-components";
import parse from "html-react-parser";
export var PoweredBy = memo(function (props) {
    var _a = props.right, right = _a === void 0 ? true : _a, divProps = __rest(props, ["right"]);
    var t = useTranslation().t;
    var poweredByUrl = useSelector(function (state) { var _a; return (_a = getOptions(state)) === null || _a === void 0 ? void 0 : _a.powered_by_link; });
    var apiBaseUrl = useSelector(function (state) { var _a; return (_a = getAppContext(state)) === null || _a === void 0 ? void 0 : _a.apiBaseUrl; });
    var label = useMemo(function () { var _a; return !poweredByUrl ? "" : parse(((_a = t("poweredBy", { apiBaseUrl: apiBaseUrl })) === null || _a === void 0 ? void 0 : _a.replace(/(?<=\w)\/\//, "/")) || ""); }, [poweredByUrl, apiBaseUrl, t]);
    if (!poweredByUrl)
        return null;
    return (React.createElement(PoweredByLinkWrapper, __assign({}, divProps, { right: right }),
        React.createElement(PoweredByLink, { href: poweredByUrl, target: "_blank" }, label)));
});
export var PoweredByWrapper = function (props) {
    var _a;
    var show = props.show, rest = __rest(props, ["show"]);
    return (React.createElement(React.Fragment, null,
        props.children,
        ((_a = props.show) !== null && _a !== void 0 ? _a : true) ? React.createElement(PoweredBy, __assign({}, rest, { right: props.right })) : null));
};
export var withPoweredBy = function (Component, right) {
    if (right === void 0) { right = true; }
    return memo(function (props) {
        return (React.createElement(PoweredByWrapper, { right: right },
            React.createElement(Component, __assign({}, props))));
    });
};
var PoweredByLinkWrapper = styled.div.attrs(function (props) { return ({ right: !!props.right }); })(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    text-align: ", ";\n    margin-top: 1em;\n"], ["\n    text-align: ", ";\n    margin-top: 1em;\n"])), function (props) { return props.right ? "right" : "center"; });
var PoweredByLink = styled.a(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n    display: inline-block !important;\n    vertical-align: middle;\n    img {\n        width: auto;\n        height: 1em;\n        vertical-align: middle;\n    }\n"], ["\n    display: inline-block !important;\n    vertical-align: middle;\n    img {\n        width: auto;\n        height: 1em;\n        vertical-align: middle;\n    }\n"])));
var templateObject_1, templateObject_2;
